import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

type AddViolationInitialState = {
  type: string;
  severity: string;
  description?: string;
  descriptionHtml?: string;
  status?: string;
  raisedFor?: {
    id: number;
    displayName: string;
  };
  raisedBy?: number;
  reportedTime?: Date;
  isSecondaryPanelOpen?: boolean;
  isPastNotesPanelOpen: boolean;
  pastNotes: any[];
  mode: 'create' | 'edit';
  editNoteId: number | null;
};

const initialState: AddViolationInitialState = {
  type: '',
  severity: 'Low',
  description: null,
  descriptionHtml: null,
  status: null,
  reportedTime: new Date(),
  isSecondaryPanelOpen: false,
  isPastNotesPanelOpen: false,
  raisedFor: null,
  pastNotes: [],
  mode: 'create',
  editNoteId: null,
};

const addViolationSlice = createSlice({
  name: 'addViolation',
  initialState,
  reducers: {
    initializeAddViolationDrawer: (state) => ({
      ...state,
      ...initialState,
    }),
    updateAddViolationDrawer: (state, action) => ({
      ...state,
      ...action.payload,
    }),
  },
});

export const { initializeAddViolationDrawer, updateAddViolationDrawer } = addViolationSlice.actions;
export default addViolationSlice.reducer;

export const useSelectAddViolationDrawerData = () =>
  useSelector((state: { addViolation: AddViolationInitialState }) => state.addViolation);
